export default __webpack_public_path__ + "static/media/Deed of Contract_01.4e6478c0.jpg";